import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, throwError } from 'rxjs';
import { ProbabilidadCierreResponse } from '../../models/probabilidad-cierre/probabilidad-cierre.model';
import { environment as ENV } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';

@Injectable({
  providedIn: 'root'
})
export class ProbabilidadCierreService {
  private readonly apiUrl = `${ENV.HOST}${URL_MAP.API.COTIZADOR_PROBABILIDAD_CIERRE}`;
  

  constructor(private httpClient: HttpClient) { }

  /**
   * Consulta las probabilidades de cierre disponibles
   * @returns Observable con la lista de probabilidades de cierre
   */
  getProbabilidadesCierre(): Observable<ProbabilidadCierreResponse> {
    return this.httpClient.get<ProbabilidadCierreResponse>(this.apiUrl).pipe(
      map((response: ProbabilidadCierreResponse) => response),
      catchError(error => {
        let errorMessage: string;
        if (error.status === 404) {
          errorMessage = 'No se encontró el recurso de probabilidades de cierre.';
        } else if (error.status === 500) {
          errorMessage = 'Error en el servidor al obtener probabilidades de cierre.';
        } else {
          errorMessage = error.error?.message || 'Error al consultar probabilidades de cierre.';
        }
        console.error('Error en getProbabilidadesCierre:', error);
        return throwError(() => errorMessage);
      })
    );
  }
}
